import React from 'react';
import PropTypes from 'prop-types';
import {useHistory} from 'react-router-dom';
import {pathnames as P} from '../../../../common/constants/pathnames';
import icon from '../../../../common/assets/date_range-4A4A4A.svg';
import styles from './styles.module.scss';

const ButtonEditShuma = ({shumaID}) => {
  const history = useHistory();

  const handleClick = () => {
    history.push(P.GET_FORM_BY_ID_AND_STEP(shumaID, 3));
  };

  return (
      <div className={styles.editItemContainer} onClick={handleClick}>
        <img src={icon}  alt="edit"/>
        <span className={styles.editItemLabel}>
          גישה לדוח
        </span>
      </div>
  );
};

ButtonEditShuma.propTypes = {
  shumaID: PropTypes.number.isRequired
};

export default ButtonEditShuma;
